<template>
<div>
  <div v-if="!itemToCheck">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            Add New Item
          </v-col>
          <v-col cols="auto">
            <EsButtonIcon icon="mdi-close"
              @click="$emit('cancel')" />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-row class="mt-2">
            <v-col cols="12">
              <EsTextField label="Name"
                v-model="newItemName"
                required />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <EsButtonCancel block
              :disabled="isSavingItem"
              @click="$emit('cancel')" />
          </v-col>
          <v-col>
            <EsButtonSave block
              :disabled="!trimmedName"
              :loading="isSavingItem"
              @click="checkItemDetails()" />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
  <div v-else>
    <v-card class="pb-1">
      <v-card-title class="px-1">
        <v-spacer></v-spacer>
        <v-col cols="auto" class="pt-0">
          <EsButtonIcon icon="mdi-close" @click="$emit('cancel')" />
        </v-col>
      </v-card-title>
      <v-card-text class="pb-5 text-center">
        <v-icon x-large class="mb-3">mdi-alert-circle-outline</v-icon>
        <p>"{{trimmedName}}" is similar to another existing item:</p>
        <p><b>{{ itemToCheck.name }}</b></p>
        <p>Add anyway?</p>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <EsButtonAction block
              label="Add Anyway"
              @click="saveItemDetails()" />
          </v-col>
          <v-col>
            <EsButtonSave block
              :label="`No, take me back`"
              @click="resetInput" />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</div>
</template>

<script>
import {
  EsButtonIcon,
  EsTextField,
  EsButtonCancel,
  EsButtonSave,
  EsButtonAction } from '@86-repairs/design-system';

export default {
  name: 'EsAddNewItem',
  props: {
    searchItem: {
      type: Function,
      required: true,
    },
  },
  components: {
    EsButtonIcon,
    EsTextField,
    EsButtonCancel,
    EsButtonSave,
    EsButtonAction
  },
  data: () => ({
    isSavingItem: false,
    newItemName: '',
    itemToCheck: null,
  }),
  computed: {
    trimmedName() {
      return (this.newItemName || '').trim();
    },
  },
  methods: {
    async saveItemDetails() {
      this.$emit('save', this.trimmedName);
      this.resetInput();
    },
    async checkItemDetails() {
      if (this.trimmedName) {
        this.isSavingItem = true;
        const searchedItems = await this.searchItem(this.trimmedName);
        const topItem = searchedItems[0];
        if (topItem) { this.itemToCheck = topItem; } else {
          this.saveItemDetails();
        }
      }
    },
    resetInput() {
      this.isSavingItem = false;
      this.itemToCheck = null;
      this.newItemName = '';
    },
  },
};
</script>
